/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {AdminResourceItemRoutePageComponent} from '../../common/controller/admin-resource-item-route-page.component';
import {getRoutePageComponent} from '../../common/controller/route-page-component-registry';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../../routing/state-utils';
import _ from 'lodash';
import {adminResourceItemRouteResolve} from '../../common/controller/admin-resource-routing';
import {ALL_LAYOUTS} from './examples/all-layouts';
import {LayoutExampleContextActionsComponent} from './layout-example-context-actions.component';
import {emptyRouteView} from '../../common/directives/html/route-view-components';


export function layoutExampleStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
const rh = adnRouterHelperProvider.$get().createRouterHelper('layout-examples.layout-example', 'LayoutExample', 'app.adm', 'app/admin');
    
        const listState = rh.list({
          views: {
            'content@app': { component: getRoutePageComponent('layout-example-route') },
            'context@app': emptyRouteView()
          }
        });
        listState.resolve = {};
        $stateProvider.state(rh.listPath(), listState);
    
        $stateProvider.state(rh.newItemPath(), rh.newItem());
    
        $stateProvider.state(rh.itemPath(), rh.modelCommsItem({
          resolve: _.merge({}, adminResourceItemRouteResolve('layout-example-edit', 'edit'), {
            model: /*@ngInject*/ function($stateParams) {
              return _.find(ALL_LAYOUTS, ['id', $stateParams.id]);
            }
          }),
          views: {
            'content@app': { component: AdminResourceItemRoutePageComponent, bindings: { item: 'adminResourceItemKey', variant: 'adminResourceItemVariant' }  },
            'context@app': {
              component: LayoutExampleContextActionsComponent,
              bindings: {model: 'model', readOnly: 'readOnly'}
            }
          }
        }, 'LayoutExample'));
  }, adnRouterHelper);
}
